var map = {
	"./ciia-2022.jpg": "e1c8",
	"./erb-md.jpg": "71fd",
	"./fintech-awards-2020.jpg": "0a5b",
	"./hk-ict-awards-2020-silver.jpg": "abae",
	"./ifta-2019.jpg": "dd7e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a7b";